import { getBoostAction } from '../helpers/WaxApi'

export const handleCreatePool = async (
    dropId,
    userName,
    activeUser,
    setCallBackCalled,
) => {
    if (!userName) return

    const transactionIds = []
    const errors = []

    const createPoolActions = [getBoostAction(activeUser)]
    const createPoolData = {
        authorized_account: userName,
        drop_id: dropId,
    }

    const createPoolAction = {
        account: 'nfthivedrops',
        name: 'createpool',
        authorization: [
            {
                actor: userName,
                permission: activeUser.requestPermission
                    ? activeUser.requestPermission
                    : 'active',
            },
        ],
        data: createPoolData,
    }

    createPoolActions.push(createPoolAction)

    try {
        const createPoolResult = await activeUser.session.transact(
            {
                actions: createPoolActions,
            },
            {
                expireSeconds: 300,
                blocksBehind: 0,
            },
        )

        transactionIds.push(createPoolResult?.response?.transaction_id)
    } catch (e) {
        errors.push(e.message)
    }
    if (errors.length === 0) {
        setCallBackCalled(true)
    }
}

export const handleSetPoolReady = async (
    dropId,
    userName,
    activeUser,
    setCallBackCalled,
    setErrors,
) => {
    if (!userName) return

    const transactionIds = []
    const errors = []

    const setPoolReadyActions = [getBoostAction(activeUser)]
    const setPoolReadyData = {
        authorized_account: userName,
        drop_id: dropId,
    }

    const setPoolReadyAction = {
        account: 'nfthivedrops',
        name: 'setready',
        authorization: [
            {
                actor: userName,
                permission: activeUser.requestPermission
                    ? activeUser.requestPermission
                    : 'active',
            },
        ],
        data: setPoolReadyData,
    }

    setPoolReadyActions.push(setPoolReadyAction)

    try {
        const setPoolReadyResult = await activeUser.session.transact(
            {
                actions: setPoolReadyActions,
            },
            {
                expireSeconds: 300,
                blocksBehind: 0,
            },
        )

        transactionIds.push(setPoolReadyResult?.response?.transaction_id)
    } catch (e) {
        errors.push(e.message)
    }

    setErrors(errors.length > 0 ? errors : null)
    if (errors.length === 0) {
        setCallBackCalled(true)
    }
}
